export const TABLE_WIDTH = 1280;
export const TABLE_HEIGHT = 800;
export const TABLE_BG = '#0d3b2a';

export const STARTING_BANKROLL_CENTS = 100_000; // $1000.00
export const DENOMINATIONS_CENTS = [
  100,      // $1
  500,      // $5
  2500,     // $25
  10000,    // $100
  50000,    // $500
  100000,   // $1,000
  500000,   // $5,000
];

/**
 * The chips a player can place at a given table. Filters out chips worth
 * less than the table minimum (the dealer would refuse them) AND chips
 * worth more than the table maximum (a single chip that exceeds the cap
 * can't be placed and just teases the player).
 *
 * The exact-tableMax chip is included — it represents the max-bet-in-one-
 * chip move, which is real Vegas convention.
 */
export function availableDenominations(
  tableMinCents: number,
  tableMaxCents: number,
): readonly number[] {
  return DENOMINATIONS_CENTS.filter((d) => d >= tableMinCents && d <= tableMaxCents);
}

export const LONG_PRESS_MS = 500;
// Hold time before the progress ring even appears, so a quick tap doesn't
// flash a "removing bet" indicator at the user.
export const LONG_PRESS_DELAY_MS = 200;
// After the initial long-press fires, the SECOND removal lags by this much so
// the user has a beat to release before more bets are pulled off.
export const LONG_PRESS_REPEAT_MS = 300;
// From the third removal onward, drain bets quickly while the pointer is held.
export const LONG_PRESS_FAST_REPEAT_MS = 80;
export const LONG_PRESS_SLOP_PX = 10;
